<template>
  <div class="Head-list-nav">
    <div class="nav-content">
      <van-tabs @click="clickTabs">
        <van-tab v-for="(item,index) in nav" :title="item.title" :key="index">
          <HeadItemTwo :list="list"></HeadItemTwo>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getData } from "../Interface/http.js";
import HeadItemTwo from "./HeadItemTwo";
import HeadItem from "./HeadItem";
export default {
  name: "HeadListNav",
  data() {
    return {
      list: [],
      id: 10
    };
  },
  components: {
    HeadItem
  },
  props: ["nav"],
  mounted() {
    this.getList();
  },
  methods: {
    clickTabs(index,title){
      this.id = this.nav[index].id;
      this.getList();
    },
    getList() {
      getData("/messages", {
        category: this.id,
        page: 1
      }).then(res => {
        this.list = [];
        this.list = res.data;
      });
    }
  },
  components: {
    HeadItemTwo
  }
};
</script>

<style scoped>
.Head-list-nav {
  position: relative;
  width: 100%;
  margin-top: 5px;
}
.nav-content {
  position: relative;
  width: 100%;
  /* height: 63px; */
  margin: 0 auto;
  border-radius: 3px;
}
.van-tabs--line{
  padding-top:5px !important;
}
</style>
